import './style.scss'
import { Popover, Switch, Tooltip } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import * as Api from '@/api/account'
import { UserStore } from '@/global-states'
import { InfoCircleOutlined } from '@ant-design/icons'

const Watermark: FC = () => {
  const { uid } = UserStore
  const [open, setOpen] = useState(true)
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (uid) {
      getConfig()
    }
  }, [uid])

  const getConfig = async () => {
    const res = await Api.getAiWatermarkSwitch()
    setOpen(!!res.enable_watermark)
    setDisabled(!res.user_can_update)
  }

  const onSwitchChange = async (v: boolean) => {
    await Api.updateAiWatermarkSwitch({ enable_watermark: v })
    setOpen(v)
  }

  if (!uid) {
    return null
  }

  return (
    <div className="vip-watermark">
      <div className="title">
        AI标识
        <Popover
          content={
            <div className="point-popover" style={{ width: '340px' }}>
              根据《人工智能生成合成内容标识办法》，您创作的作品会默认打上显式和隐式水印。根据您的实际业务情况，可进行AI显式标识开关的配置。
            </div>
          }
          placement="right"
        >
          <InfoCircleOutlined />
        </Popover>
      </div>
      <div className="watermark-detail">
        <div className="label">显示标识AI生成：</div>
        <Tooltip title={disabled ? '会员用户可选择关闭显式水印' : ''}>
          <Switch disabled={disabled} checked={open} onChange={onSwitchChange} />
        </Tooltip>
      </div>
    </div>
  )
}

export default memo(Watermark)
